module.exports = __webpack_public_path__ + "static/media/oauth-2.0-logo.b3e30e3d.png";